import { css, keyframes } from "@emotion/react";
import { rem } from "polished";
import React from "react";

import { Colors } from "./theme";

const spin = keyframes`
  from {
      transform:rotate(0deg);
  }
  to {
      transform:rotate(360deg);
  }
`;

const LoadingRing = ({ size = 22 }) => (
  <img
    alt=""
    css={css`
      width: ${size}px;
      height: ${size}px;
      object-fit: contain;
      transform: rotate(-90deg);
      background-image: conic-gradient(
        rgba(148, 25, 255, 0) 30%,
        ${Colors.primary} 30%,
        rgba(148, 25, 255, 0) 30%
      );
      animation: ${spin} 1s linear infinite;
    `}
    src="/assets/img/loading-spinner@2x.png"
  />
);

export default LoadingRing;

const LoadingRingWhite = ({ size = 18 }) => (
  <img
    alt=""
    css={css`
      width: ${rem(size)};
      height: ${rem(size)};
      object-fit: contain;
      transform: rotate(-90deg);
      animation: ${spin} 1s linear infinite;
    `}
    src="/assets/img/oval-white/oval@3x.png"
  />
);

export { LoadingRingWhite };
